import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";

interface UseDeleteEquipmentCategoryProps {
  privateCompanyLeadId?: string
  onSuccess: () => void
  onError: () => void
}

const useDeletePrivateCompanyLeadEquipmentCategory = ({ privateCompanyLeadId, onSuccess, onError }: UseDeleteEquipmentCategoryProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['deleteEquipmentCategory'],
    mutationFn: async (id: string) => {
      const private_company_lead = {
        contract_attributes: {
          contract_equipment_categories_attributes: [
            {
              id,
              _destroy: true
            }
          ]
        }
      }

      await privateAxios.putForm(`/funnel/private_company_leads/${privateCompanyLeadId}`, {
        private_company_lead
      })
    },
    onSuccess,
    onError,
  })
}

export default useDeletePrivateCompanyLeadEquipmentCategory